'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const PickUpStoreIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M2.2 21.9L2 20.9L8.5 19.8C9.1 19.7 9.7 19.6 10.3 19.6H14.6C15 19.6 15.3 19.5 15.7 19.4C17.9 18.4 20.6 17.1 20.6 17.1C20.9 17 21 16.6 20.9 16.4C20.8 16.3 20.7 16.2 20.6 16.1C20.5 16 20.3 16.1 20.2 16.1L16.4 17.9C16.3 18.1 16.1 18.3 15.9 18.4C15.6 18.6 15.1 18.7 14.7 18.7L10.8 18L11 17L14.9 17.7C15.1 17.7 15.2 17.7 15.3 17.6C15.4 17.5 15.5 17.4 15.5 17.2C15.6 16.9 15.4 16.6 15 16.5L11.8 16C11.1 15.9 10.4 16 9.7 16.3L7.6 17.2L2.2 18L2 17L7.4 16.3L9.3 15.4C10.1 15 11 14.8 12 15L15.3 15.6C15.9 15.7 16.4 16.2 16.5 16.7L19.8 15.2C20.2 15 20.6 15 21 15.1C21.4 15.2 21.7 15.5 21.9 15.9C22.3 16.7 21.9 17.6 21.2 18C21.2 18 18.5 19.3 16.3 20.3C15.8 20.5 15.3 20.6 14.8 20.6H10.5C9.9 20.6 9.4 20.6 8.8 20.7L2.2 21.9ZM15.2 13.2H8.8C8.3 13.2 7.9 12.9 7.8 12.4L6.5 6.50001H17.5L16.2 12.3C16.1 12.8 15.7 13.2 15.2 13.2ZM7.7 7.50001L8.7 12.1H15.1L16.1 7.50001H7.7ZM14.5 5.80001H13.5C13.5 4.30001 12.8 3.20001 12 3.20001C11.2 3.20001 10.5 4.30001 10.5 5.80001H9.5C9.5 3.70001 10.6 2.20001 12 2.20001C13.4 2.20001 14.5 3.80001 14.5 5.80001Z",
        fill: "currentColor"
      }
    )
  }
);
const VpPickUpStoreIcon = forwardRef(PickUpStoreIcon);

export { VpPickUpStoreIcon as default };
